import clsx from "clsx";
import { Outlet } from "react-router-dom";
import { Footer } from "./components/footer/Footer";
import Navbar from "./components/navbar/Navbar";
import FloatingBTN from "main/components/componentsHelper/Landgingpage/FloatingBTN";

export const MasterLayout = () => {
  return (
    <>
      <div data-testid="master">
        {/* begin::Page */}
        <div className="container-fluid">
          {/* NavBar */}
          <Navbar />
        </div>
        <div className="container-fluid min-vh-90">
          {/* Main Connent Comes here, in privateRoutes whatever the routes be there comes here */}
          <FloatingBTN />
          <Outlet />
        </div>
        <div>
          <Footer />
        </div>
        {/* end::Wrapper */}
        {/* end::Page */}
      </div>
    </>
  );
};
